export * from './search-icon'